module.exports = __webpack_public_path__ + "media/luxury-2026/blue-library-960-442fddd0.jpg";